"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOURCE_SPACE_RW_NATURE_10 = exports.SOURCE_SPACE_RW_GARAGE_24 = exports.SOURCE_SPACE_RW_GARAGE_18 = exports.SOURCE_SPACE_RW_GARAGE_12 = exports.SOURCE_SPACE_RW_GARAGE_6 = exports.SOURCE_SPACE_RW_STARTUP_150 = exports.SOURCE_SPACE_RW_STARTUP_124 = exports.SOURCE_SPACE_RW_STARTUP_108 = exports.SOURCE_SPACE_RW_STARTUP_84 = exports.SOURCE_SPACE_RW_STARTUP_66 = exports.SOURCE_SPACE_RW_STARTUP_48 = exports.SOURCE_SPACE_RW_STARTUP_36 = exports.SOURCE_SPACE_RW_STARTUP_24 = exports.SOURCE_SPACE_RW_STARTUP_18 = exports.SOURCE_SPACE_RW_STARTUP_12 = exports.SOURCE_SPACE_RW_STARTUP_6 = exports.SOURCE_SPACE_RW_TOWER_24 = exports.SOURCE_SPACE_RW_TOWER_18 = exports.SOURCE_SPACE_RW_TOWER_12 = exports.SOURCE_SPACE_RW_TOWER_6 = exports.SOURCE_SPACE_RW_OFFICE_SMALL_WOOD = exports.SOURCE_SPACE_RW_150 = exports.SOURCE_SPACE_RW_124 = exports.SOURCE_SPACE_RW_108 = exports.SOURCE_SPACE_RW_84 = exports.SOURCE_SPACE_RW_66 = exports.SOURCE_SPACE_RW_48 = exports.SOURCE_SPACE_RW_36 = exports.SOURCE_SPACE_RW_24 = exports.SOURCE_SPACE_RW_18 = exports.SOURCE_SPACE_RW_12 = exports.SOURCE_SPACE_RW_6 = exports.isOnboardingMap = exports.ONBOARDING_MAPS = exports.REMOTE_WORK_EVENT_HANGOUT = exports.REMOTE_WORK_OFFICE = exports.REMOTE_WORK_PLAYGROUND = exports.ONBOARDING_MAP_RW_150 = exports.ONBOARDING_MAP_RW_124 = exports.ONBOARDING_MAP_RW_108 = exports.ONBOARDING_MAP_RW_84 = exports.ONBOARDING_MAP_RW_66 = exports.ONBOARDING_MAP_RW_48 = exports.ONBOARDING_MAP_RW_36 = exports.ONBOARDING_MAP_RW_24 = exports.ONBOARDING_MAP_RW_18 = exports.ONBOARDING_MAP_RW_12 = exports.ONBOARDING_MAP_RW_6 = exports.ONBOARDING_MAP_NAME = exports.MapAction = void 0;
exports.DRAFT_SPACE_RW_150 = exports.DRAFT_SPACE_RW_124 = exports.DRAFT_SPACE_RW_108 = exports.DRAFT_SPACE_RW_84 = exports.DRAFT_SPACE_RW_66 = exports.DRAFT_SPACE_RW_48 = exports.DRAFT_SPACE_RW_36 = exports.DRAFT_SPACE_RW_24 = exports.DRAFT_SPACE_RW_18 = exports.DRAFT_SPACE_RW_12 = exports.DRAFT_SPACE_RW_6 = exports.SOURCE_SPACE_RW_MODERN_100 = exports.SOURCE_SPACE_RW_MODERN_90 = exports.SOURCE_SPACE_RW_MODERN_80 = exports.SOURCE_SPACE_RW_MODERN_70 = exports.SOURCE_SPACE_RW_MODERN_60 = exports.SOURCE_SPACE_RW_MODERN_50 = exports.SOURCE_SPACE_RW_MODERN_40 = exports.SOURCE_SPACE_RW_MODERN_30 = exports.SOURCE_SPACE_RW_MODERN_20 = exports.SOURCE_SPACE_RW_MODERN_10 = exports.SOURCE_SPACE_RW_COZY_100 = exports.SOURCE_SPACE_RW_COZY_90 = exports.SOURCE_SPACE_RW_COZY_80 = exports.SOURCE_SPACE_RW_COZY_70 = exports.SOURCE_SPACE_RW_COZY_60 = exports.SOURCE_SPACE_RW_COZY_50 = exports.SOURCE_SPACE_RW_COZY_40 = exports.SOURCE_SPACE_RW_COZY_30 = exports.SOURCE_SPACE_RW_COZY_20 = exports.SOURCE_SPACE_RW_COZY_10 = exports.SOURCE_SPACE_RW_FUTURE_100 = exports.SOURCE_SPACE_RW_FUTURE_90 = exports.SOURCE_SPACE_RW_FUTURE_80 = exports.SOURCE_SPACE_RW_FUTURE_70 = exports.SOURCE_SPACE_RW_FUTURE_60 = exports.SOURCE_SPACE_RW_FUTURE_50 = exports.SOURCE_SPACE_RW_FUTURE_40 = exports.SOURCE_SPACE_RW_FUTURE_30 = exports.SOURCE_SPACE_RW_FUTURE_20 = exports.SOURCE_SPACE_RW_NATURE_100 = exports.SOURCE_SPACE_RW_NATURE_90 = exports.SOURCE_SPACE_RW_NATURE_80 = exports.SOURCE_SPACE_RW_NATURE_70 = exports.SOURCE_SPACE_RW_NATURE_60 = exports.SOURCE_SPACE_RW_NATURE_50 = exports.SOURCE_SPACE_RW_FUTURE_10 = exports.SOURCE_SPACE_RW_NATURE_40 = exports.SOURCE_SPACE_RW_NATURE_30 = exports.SOURCE_SPACE_RW_NATURE_20 = void 0;
exports.RWE_HANGOUT_SPACE = exports.DEFAULT_OFFICE_SPACE_NAME = exports.RW_ALLHANDS_GUIDE_KIOSK_NAME = exports.RW_TIPS_GUIDE_KIOSK_NAME = exports.ONBOARDING_HEADER_GATHER_IMAGE = exports.ONBOARDING_HEADER_PEOPLE_IMAGE = exports.RW_ONBOARDING_AREA_SPAWN_IDS = exports.RW_PRIVATE_AREA_AREA_ID = exports.RW_COWORKING_AREA_ID = exports.RWE_GAMES_ID = exports.RWE_STAGE_ID = exports.RW_DESK_AREA_ID = exports.RW_OUTSIDE_MEETING_ROOM_ID = exports.RW_MEETING_ROOM_ID = exports.RW_SOCIAL_AREA_ID = exports.RW_GAMES_AREA_ID = exports.RW_ALL_HANDS_AREA_ID = exports.RW_LUNCH_AREA_ID = exports.RW_LOBBY_AREA_ID = exports.BUILD_LOBBY_CONTAINER_AREA_ID = exports.BUILD_LOBBY_AREA_ID = exports.isRWTemplateSpace = exports.RWTemplateSpacesNonOnboarding = exports.RWTemplateSpacesOnboarding = exports.RW_JUNE_2023_TEMPLATES = exports.DRAFT_SPACE_RW_OFFICE_MEDIUM_WOOD = exports.DRAFT_SPACE_RW_OFFICE_SMALL_WOOD = void 0;
var MapAction;
(function (MapAction) {
    MapAction["AddLunch"] = "add-lunch";
    MapAction["AddAllHands"] = "add-all-hands";
    MapAction["AddMeeting"] = "add-meeting";
})(MapAction || (exports.MapAction = MapAction = {}));
exports.ONBOARDING_MAP_NAME = "office-complex-onboarding";
exports.ONBOARDING_MAP_RW_6 = "rw-6";
exports.ONBOARDING_MAP_RW_12 = "rw-12";
exports.ONBOARDING_MAP_RW_18 = "rw-18";
exports.ONBOARDING_MAP_RW_24 = "rw-24";
exports.ONBOARDING_MAP_RW_36 = "rw-36";
exports.ONBOARDING_MAP_RW_48 = "rw-48";
exports.ONBOARDING_MAP_RW_66 = "rw-66";
exports.ONBOARDING_MAP_RW_84 = "rw-84";
exports.ONBOARDING_MAP_RW_108 = "rw-108";
exports.ONBOARDING_MAP_RW_124 = "rw-124";
exports.ONBOARDING_MAP_RW_150 = "rw-150";
exports.REMOTE_WORK_PLAYGROUND = "office-socials";
exports.REMOTE_WORK_OFFICE = "office-main";
exports.REMOTE_WORK_EVENT_HANGOUT = "rwe-hangout";
exports.ONBOARDING_MAPS = [
    "rw-first-tiny",
    exports.ONBOARDING_MAP_RW_6,
    exports.ONBOARDING_MAP_RW_12,
    exports.ONBOARDING_MAP_RW_18,
    exports.ONBOARDING_MAP_RW_24,
    exports.ONBOARDING_MAP_RW_36,
    exports.ONBOARDING_MAP_RW_48,
    exports.ONBOARDING_MAP_RW_66,
    exports.ONBOARDING_MAP_RW_84,
    exports.ONBOARDING_MAP_RW_108,
    exports.ONBOARDING_MAP_RW_124,
    exports.ONBOARDING_MAP_RW_150,
    exports.REMOTE_WORK_OFFICE,
];
const isOnboardingMap = (currentMap) => exports.ONBOARDING_MAPS.includes(currentMap);
exports.isOnboardingMap = isOnboardingMap;
exports.SOURCE_SPACE_RW_6 = "gdP41hEEkV7JKRqh\\TEMPLATE_rw-6";
exports.SOURCE_SPACE_RW_12 = "LHS7cOjFzXeOeFy7\\TEMPLATE_rw-12";
exports.SOURCE_SPACE_RW_18 = "471CfJzNJeKK1C1a\\TEMPLATE_rw-18";
exports.SOURCE_SPACE_RW_24 = "f1wsgkaVwq7N0EPY\\TEMPLATE_rw-24";
exports.SOURCE_SPACE_RW_36 = "pYeHFacEs8Zhxaff\\TEMPLATE_rw-36";
exports.SOURCE_SPACE_RW_48 = "q3RuKxo2Sb70W0R3\\TEMPLATE_rw-48";
exports.SOURCE_SPACE_RW_66 = "O1qItDGalmPqLmdJ\\TEMPLATE_rw-66";
exports.SOURCE_SPACE_RW_84 = "8DH8obnxJe9khNGo\\TEMPLATE_rw-84";
exports.SOURCE_SPACE_RW_108 = "4V9nyd0STtEEicec\\TEMPLATE_rw-108";
exports.SOURCE_SPACE_RW_124 = "OaThdug06aDjGBLU\\TEMPLATE_rw-124";
exports.SOURCE_SPACE_RW_150 = "3zzKKTbtk8733VIL\\TEMPLATE_rw-150";
exports.SOURCE_SPACE_RW_OFFICE_SMALL_WOOD = "93UZz21GCXja3Fns\\TEMPLATE_office-sm-wood";
exports.SOURCE_SPACE_RW_TOWER_6 = "tJGxYYSYs52TwUOL\\TEMPLATE_ModernOfficeTiny";
exports.SOURCE_SPACE_RW_TOWER_12 = "cNwCT964BM4YXv9D\\TEMPLATE_ModernOffice12";
exports.SOURCE_SPACE_RW_TOWER_18 = "b3u1xZTwCsZvHUf4\\TEMPLATE_ModernOffice18";
exports.SOURCE_SPACE_RW_TOWER_24 = "sg0AMwN84o8rG3Zg\\TEMPLATE_ModernOffice24";
exports.SOURCE_SPACE_RW_STARTUP_6 = "EvL7MsrV5yjxEseU\\TEMPLATE_StartupOffice6";
exports.SOURCE_SPACE_RW_STARTUP_12 = "xZlyvGpO7lzHhpK4\\TEMPLATE_StartupOffice12";
exports.SOURCE_SPACE_RW_STARTUP_18 = "b9DbA1th9g9igEzA\\TEMPLATE_StartupOffice18";
exports.SOURCE_SPACE_RW_STARTUP_24 = "BBNU30LJotdnXWFR\\TEMPLATE_StartupOffice24";
exports.SOURCE_SPACE_RW_STARTUP_36 = "eFiXGCzAzHVCt4Lb\\TEMPLATE_StartupOffice36";
exports.SOURCE_SPACE_RW_STARTUP_48 = "K3CyPGBDgvGBs7qd\\TEMPLATE_StartupOffice48";
exports.SOURCE_SPACE_RW_STARTUP_66 = "xC0Pj4VNDiIFmsYn\\TEMPLATE_StartupOffice66";
exports.SOURCE_SPACE_RW_STARTUP_84 = "Ft32EZiCGLOW62Bh\\TEMPLATE_StartupOffice84";
exports.SOURCE_SPACE_RW_STARTUP_108 = "R77Ky0bh1jKmulr2\\TEMPLATE_StartupOffice108";
exports.SOURCE_SPACE_RW_STARTUP_124 = "v59gmKCRz1ZG9Ymr\\TEMPLATE_StartupOffice124";
exports.SOURCE_SPACE_RW_STARTUP_150 = "xMF57Pq3sYt6jOxh\\TEMPLATE_StartupOffice150";
exports.SOURCE_SPACE_RW_GARAGE_6 = "1BxpRm5mDFzyuzoo\\TEMPLATE_IndustrialOffice6";
exports.SOURCE_SPACE_RW_GARAGE_12 = "b2AZmOlDNbH5iN2C\\TEMPLATE_IndustrialOffic12";
exports.SOURCE_SPACE_RW_GARAGE_18 = "0xQOrtxaffOp36Ur\\TEMPLATE_Industrial18";
exports.SOURCE_SPACE_RW_GARAGE_24 = "Bb06M7eH509Hg4MW\\TEMPLATE_IndustrialOffic24";
exports.SOURCE_SPACE_RW_NATURE_10 = "tKGPBFz9pUw2gPTd\\PUBLISHED_templateUFP10Nature";
exports.SOURCE_SPACE_RW_NATURE_20 = "RCzh5EusSlDMhWts\\PUBLISHED_templateUFP20Nature";
exports.SOURCE_SPACE_RW_NATURE_30 = "brHvCTO9f3bIb47H\\PUBLISHED_templateUFP30Nature";
exports.SOURCE_SPACE_RW_NATURE_40 = "jRlUhgW0rc9cZEEx\\PUBLISHED_templateUFP40Nature";
exports.SOURCE_SPACE_RW_FUTURE_10 = "MSUxigcunwzehmvb\\PUBLISHED_templateUFP10Future";
exports.SOURCE_SPACE_RW_NATURE_50 = "6ruSn5dkA54f34r6\\PUBLISHED_templateUFP50Nature";
exports.SOURCE_SPACE_RW_NATURE_60 = "8YNKG981isE2GotE\\PUBLISHED_templateUFP60Nature";
exports.SOURCE_SPACE_RW_NATURE_70 = "27XYkvTLoTdwC25E\\PUBLISHED_templateUFP70Nature";
exports.SOURCE_SPACE_RW_NATURE_80 = "f5U515WzXpmq5pI8\\PUBLISHED_templateUFP80Nature";
exports.SOURCE_SPACE_RW_NATURE_90 = "uFTU2YlIsSAuz3uG\\PUBLISHED_templateUFP90Nature";
exports.SOURCE_SPACE_RW_NATURE_100 = "rjlqpBadWLnMtUqB\\PUBLISHED_templateUFP100Nature";
exports.SOURCE_SPACE_RW_FUTURE_20 = "0NpvMrmMo5vdHYS9\\PUBLISHED_templateUFP20Future";
exports.SOURCE_SPACE_RW_FUTURE_30 = "KVAR6rhdbkMJhbqV\\PUBLISHED_templateUFP30Future";
exports.SOURCE_SPACE_RW_FUTURE_40 = "lMFl0ShFF5xPAjOS\\PUBLISHED_templateUFP40Future";
exports.SOURCE_SPACE_RW_FUTURE_50 = "2f01jGXDfwgC1xQn\\PUBLISHED_templateUFP50Future";
exports.SOURCE_SPACE_RW_FUTURE_60 = "yeFIXsJNRcBOmaUx\\PUBLISHED_templateUFP60Future";
exports.SOURCE_SPACE_RW_FUTURE_70 = "3jtE6UIChwLSzXB6\\PUBLISHED_templateUFP70Future";
exports.SOURCE_SPACE_RW_FUTURE_80 = "7xlrf0Ml9K6DQDm5\\PUBLISHED_templateUFP80Future";
exports.SOURCE_SPACE_RW_FUTURE_90 = "2G3WLA7ZGUVAEIAi\\PUBLISHED_templateUFP90Future";
exports.SOURCE_SPACE_RW_FUTURE_100 = "LwPJ56SijKqknv9s\\PUBLISHED_templateUFP100Future";
exports.SOURCE_SPACE_RW_COZY_10 = "IkxKghbaLIFs9EWo\\PUBLISHED_templateUFP10Cozy";
exports.SOURCE_SPACE_RW_COZY_20 = "qobqTpy1mzEFaAOw\\PUBLISHED_templateUFP20Cozy";
exports.SOURCE_SPACE_RW_COZY_30 = "IWgwF5si92PZMXHl\\PUBLISHED_templateUFP30Cozy";
exports.SOURCE_SPACE_RW_COZY_40 = "uBDbDs4nnXOTKQk6\\PUBLISHED_templateUFP40Cozy";
exports.SOURCE_SPACE_RW_COZY_50 = "IoF91dmKRGzxoA35\\PUBLISHED_templateUFP50Cozy";
exports.SOURCE_SPACE_RW_COZY_60 = "tXY0KYR2goJ913H6\\PUBLISHED_templateUFP60Cozy";
exports.SOURCE_SPACE_RW_COZY_70 = "WiAKgNpZ8LdVyQ6q\\PUBLISHED_templateUFP70Cozy";
exports.SOURCE_SPACE_RW_COZY_80 = "uQ1RFi7t5t9HEQhp\\PUBLISHED_templateUFP80Cozy";
exports.SOURCE_SPACE_RW_COZY_90 = "UQdL8Da5u4ieXbxI\\PUBLISHED_templateUFP90Cozy";
exports.SOURCE_SPACE_RW_COZY_100 = "9T5lR8PQ8CHThK1t\\PUBLISHED_templateUFP100Cozy";
exports.SOURCE_SPACE_RW_MODERN_10 = "a8I8VdmaJhalm5cN\\PUBLISHED_testUFP10";
exports.SOURCE_SPACE_RW_MODERN_20 = "noFEgoOpnYcztb0b\\PUBLISHED_testUFP20";
exports.SOURCE_SPACE_RW_MODERN_30 = "lpS9SIvnCH87cFzU\\PUBLISHED_testUFP30";
exports.SOURCE_SPACE_RW_MODERN_40 = "dKccC9UbDJaTC6h0\\PUBLISHED_UFP40alt";
exports.SOURCE_SPACE_RW_MODERN_50 = "L5nw5Dr87LmvPFDy\\PUBLISHED_UFP50alt";
exports.SOURCE_SPACE_RW_MODERN_60 = "C8KKbfOn1IRFW9fB\\PUBLISHED_UFP60alt";
exports.SOURCE_SPACE_RW_MODERN_70 = "St205XxKr80f0TNn\\PUBLISHED_UFP70";
exports.SOURCE_SPACE_RW_MODERN_80 = "vvIOJp5d6TwFX35B\\PUBLISHED_UFP 80";
exports.SOURCE_SPACE_RW_MODERN_90 = "Wud2Y0yv5KKlEKtW\\PUBLISHED_UFP90";
exports.SOURCE_SPACE_RW_MODERN_100 = "fLNeOGCzWYMs7N17\\PUBLISHED_UFP100";
exports.DRAFT_SPACE_RW_6 = "9YztzTnWybYDklVO\\DRAFT_rw-6";
exports.DRAFT_SPACE_RW_12 = "XSSjPX1gOGFp4VSh\\DRAFT_rw-12";
exports.DRAFT_SPACE_RW_18 = "USfXp1apNLov2jZu\\DRAFT_rw-18";
exports.DRAFT_SPACE_RW_24 = "iFr5FLzG81O3mXbh\\DRAFT_rw-24";
exports.DRAFT_SPACE_RW_36 = "OIUjKP4f8fUczAwe\\DRAFT_rw-36";
exports.DRAFT_SPACE_RW_48 = "b8vltQ7cFdccjCV4\\DRAFT_rw-48";
exports.DRAFT_SPACE_RW_66 = "u9tL3RqSNAjEvkgE\\DRAFT_rw-66";
exports.DRAFT_SPACE_RW_84 = "2X7YQu27OcBy2WI6\\DRAFT_rw-84";
exports.DRAFT_SPACE_RW_108 = "O6gjb3h4kiTRPJTP\\DRAFT_rw-108";
exports.DRAFT_SPACE_RW_124 = "ouygIJ6rRxaxoILI\\DRAFT_rw-124";
exports.DRAFT_SPACE_RW_150 = "qLW00GaJhur5b21Z\\DRAFT_rw-150";
exports.DRAFT_SPACE_RW_OFFICE_SMALL_WOOD = "EwpHBZE5NeYjVa7y\\DRAFT_office-sm-wood";
exports.DRAFT_SPACE_RW_OFFICE_MEDIUM_WOOD = "BbwY1jwiDxxse7il\\DRAFT_office-md-wood";
exports.RW_JUNE_2023_TEMPLATES = [
    exports.SOURCE_SPACE_RW_NATURE_10,
    exports.SOURCE_SPACE_RW_NATURE_20,
    exports.SOURCE_SPACE_RW_NATURE_30,
    exports.SOURCE_SPACE_RW_NATURE_40,
    exports.SOURCE_SPACE_RW_NATURE_50,
    exports.SOURCE_SPACE_RW_NATURE_60,
    exports.SOURCE_SPACE_RW_NATURE_70,
    exports.SOURCE_SPACE_RW_NATURE_80,
    exports.SOURCE_SPACE_RW_NATURE_90,
    exports.SOURCE_SPACE_RW_NATURE_100,
    exports.SOURCE_SPACE_RW_FUTURE_10,
    exports.SOURCE_SPACE_RW_FUTURE_20,
    exports.SOURCE_SPACE_RW_FUTURE_30,
    exports.SOURCE_SPACE_RW_FUTURE_40,
    exports.SOURCE_SPACE_RW_FUTURE_50,
    exports.SOURCE_SPACE_RW_FUTURE_60,
    exports.SOURCE_SPACE_RW_FUTURE_70,
    exports.SOURCE_SPACE_RW_FUTURE_80,
    exports.SOURCE_SPACE_RW_FUTURE_90,
    exports.SOURCE_SPACE_RW_FUTURE_100,
    exports.SOURCE_SPACE_RW_COZY_10,
    exports.SOURCE_SPACE_RW_COZY_20,
    exports.SOURCE_SPACE_RW_COZY_30,
    exports.SOURCE_SPACE_RW_COZY_40,
    exports.SOURCE_SPACE_RW_COZY_50,
    exports.SOURCE_SPACE_RW_COZY_60,
    exports.SOURCE_SPACE_RW_COZY_70,
    exports.SOURCE_SPACE_RW_COZY_80,
    exports.SOURCE_SPACE_RW_COZY_90,
    exports.SOURCE_SPACE_RW_COZY_100,
    exports.SOURCE_SPACE_RW_MODERN_10,
    exports.SOURCE_SPACE_RW_MODERN_20,
    exports.SOURCE_SPACE_RW_MODERN_30,
    exports.SOURCE_SPACE_RW_MODERN_40,
    exports.SOURCE_SPACE_RW_MODERN_50,
    exports.SOURCE_SPACE_RW_MODERN_60,
    exports.SOURCE_SPACE_RW_MODERN_70,
    exports.SOURCE_SPACE_RW_MODERN_80,
    exports.SOURCE_SPACE_RW_MODERN_90,
    exports.SOURCE_SPACE_RW_MODERN_100,
];
exports.RWTemplateSpacesOnboarding = [
    exports.SOURCE_SPACE_RW_6,
    exports.SOURCE_SPACE_RW_12,
    exports.SOURCE_SPACE_RW_18,
    exports.SOURCE_SPACE_RW_24,
    exports.SOURCE_SPACE_RW_36,
    exports.SOURCE_SPACE_RW_48,
    exports.SOURCE_SPACE_RW_66,
    exports.SOURCE_SPACE_RW_84,
    exports.SOURCE_SPACE_RW_108,
    exports.SOURCE_SPACE_RW_124,
    exports.SOURCE_SPACE_RW_150,
    exports.DRAFT_SPACE_RW_6,
    exports.DRAFT_SPACE_RW_12,
    exports.DRAFT_SPACE_RW_18,
    exports.DRAFT_SPACE_RW_24,
    exports.DRAFT_SPACE_RW_36,
    exports.DRAFT_SPACE_RW_48,
    exports.DRAFT_SPACE_RW_66,
    exports.DRAFT_SPACE_RW_84,
    exports.DRAFT_SPACE_RW_108,
    exports.DRAFT_SPACE_RW_124,
    exports.DRAFT_SPACE_RW_150,
];
exports.RWTemplateSpacesNonOnboarding = [
    exports.SOURCE_SPACE_RW_OFFICE_SMALL_WOOD,
    exports.DRAFT_SPACE_RW_OFFICE_SMALL_WOOD,
    exports.DRAFT_SPACE_RW_OFFICE_MEDIUM_WOOD,
];
const isRWTemplateSpace = (spaceId) => exports.RWTemplateSpacesOnboarding.includes(spaceId) || exports.RWTemplateSpacesNonOnboarding.includes(spaceId);
exports.isRWTemplateSpace = isRWTemplateSpace;
exports.BUILD_LOBBY_AREA_ID = "build-lobby";
exports.BUILD_LOBBY_CONTAINER_AREA_ID = "build-lobby-container";
exports.RW_LOBBY_AREA_ID = "lobby";
exports.RW_LUNCH_AREA_ID = "lunch area";
exports.RW_ALL_HANDS_AREA_ID = "all hands";
exports.RW_GAMES_AREA_ID = "games area";
exports.RW_SOCIAL_AREA_ID = "social area";
exports.RW_MEETING_ROOM_ID = "meeting room";
exports.RW_OUTSIDE_MEETING_ROOM_ID = "outside meeting room";
exports.RW_DESK_AREA_ID = "desk area";
exports.RWE_STAGE_ID = "stage area";
exports.RWE_GAMES_ID = "rwe games area";
exports.RW_COWORKING_AREA_ID = "coworking";
exports.RW_PRIVATE_AREA_AREA_ID = "private area area";
exports.RW_ONBOARDING_AREA_SPAWN_IDS = {
    [exports.RW_ALL_HANDS_AREA_ID]: "all-hands",
    [exports.RW_LUNCH_AREA_ID]: "luncharea",
    [exports.RW_GAMES_AREA_ID]: "gamesarea",
    [exports.RW_MEETING_ROOM_ID]: "meetingroom",
    [exports.RW_DESK_AREA_ID]: "deskarea",
    [exports.RW_SOCIAL_AREA_ID]: "socialarea",
};
exports.ONBOARDING_HEADER_PEOPLE_IMAGE = "/images/remoteWorkOnboarding/onboarding-header-people.png";
exports.ONBOARDING_HEADER_GATHER_IMAGE = "/images/remoteWorkOnboarding/onboarding-header-gather.png";
exports.RW_TIPS_GUIDE_KIOSK_NAME = "Remote Work Tips Guide Kiosk";
exports.RW_ALLHANDS_GUIDE_KIOSK_NAME = "Remote Work All-Hands Guide Kiosk";
exports.DEFAULT_OFFICE_SPACE_NAME = "My Office";
exports.RWE_HANGOUT_SPACE = "a1c4efZydYUOJswk\\TEMPLATE_DO_NOT_EDIT_RWE_Hangout";
//# sourceMappingURL=remoteWorkOnboarding.js.map